var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-12 col-md-6 col-lg-4 p-2 col-print-third",class:{'d-lg-none': _vm.index >= 6}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }